import {Injectable} from '@angular/core';
import {Offer} from '../../core/models/offer/offer.model';
import {BusinessParamName} from '../models/request-offer/request-offer.enum';
import {NavigateManagerService} from '../../core/services/navigate-manager.service';
import {ApplicationStateService} from './application-state.service';
import {ProcessService} from '../../core/services/process.service';

@Injectable({
  providedIn: 'root'
})
export class OfferNumberService {

  offer: Offer;

  constructor(private navigateManager: NavigateManagerService,
              private stateService: ApplicationStateService,
              private processService: ProcessService) {
  }

  getQuotationId(): string {
    if (this.navigateManager.isThirdStep) {
      return <string>this.stateService.getBusinessParameterValue(BusinessParamName.QUOTATION_ID)
    }
    return null;
  }

  getOfferNumber(context: OfferNumberContext): string {
    switch (context) {
      case OfferNumberContext.HEADER:
        return this.offerNumberForHeader;
      case OfferNumberContext.OFFER_PRESENTATION:
        return this.offerNumberForOfferPresentation;
    }
  }

  get numberLabel(): string {
    if (this.navigateManager.isOcDetailsStep) {
      return 'SEND-OFFER_COMPONENT.sessionNumber';
    }
    if (this.navigateManager.isOffersStep) {
      return 'SEND-OFFER_COMPONENT.calculationNumber';
    }
    return 'SEND-OFFER_COMPONENT.offerNumber';
  }

  get offerNumberForHeader(): string {
    if (this.navigateManager.isOcDetailsStep) {
      return this.processService.sessionSimpleId;
    }
    if (this.navigateManager.isOffersStep) {
      return <string>this.stateService.getBusinessParameterValue(BusinessParamName.CALCULATION_SIMPLE_ID);
    }
    if (this.navigateManager.isOrderPolicyStep) {
      return this.stateService.selectedOffer ? this.stateService.selectedOffer.simpleId : '';
    }
    if (this.navigateManager.isNotificationStep) { // notification
      return <string>this.stateService.getBusinessParameterValue(BusinessParamName.CALCULATION_SIMPLE_ID);
    }
  }

  private get offerNumberForOfferPresentation(): string {
    return this.offer.simpleId;
  }
}

export enum OfferNumberContext {
  HEADER = 'HEADER',
  OFFER_PRESENTATION = 'OFFER_PRESENTATION'
}
